const buildBraceletCrn = (tenantSlug, braceletId) => `crn:perfect::${tenantSlug}:bracelet:${braceletId}`;
const getSerialnumberFromCrn = (crn) => crn.split(":").pop();

export { buildBraceletCrn, getSerialnumberFromCrn };
